import React, { ReactNode } from 'react';

interface StatusBadgeProps {
  title: string,
  variant: 'success' | 'primary' | 'error' | ''|'pending' | 'cancelled' | 'running' | '';
  className?: string;
}

const renderBadge = (title: string, variant: string, className?: string) => {
  switch (variant) {
    case 'primary': 
      return <div className="bg-[#F17A20] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">{title}</div>
      break;
    case 'success': 
      return <div className="bg-[#04b34f] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">{title}</div>
      break;
    case 'error':
      return <div className="bg-[#d32f2f] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">{title}</div>
      break;
    case 'pending':
      return (
        <div className="bg-[#facc15] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">
          {title}
        </div>
    );
    case 'scheduled':
      return <div className={`bg-orange-400 text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px] ${className ? className : ''}`}>{title}</div>
      break;
    case 'cancelled':
      return <div className="bg-[#d32f2f] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">{title}</div>
      break;
    case 'running':
      return <div className="bg-[#facc15] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">{title}</div>
      break;
    default: 
      return <div className="bg-[#F17A20] text-white text-xs font-medium me-2 py-0.5 rounded text-center w-[110px]">{title}</div>
      break;
  } 
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ title, variant = 'primary' }) => {
  return (
    <>{renderBadge(title, variant)}</>
  )
};